<ng-template #template
    let-model="model"
    let-data="data"
>
    <div class="mibi-text-cell"
        [ngClass]="{
            'mibi-text-cell--readonly': model.isReadOnly,
            'mibi-text-cell--col-header': model.isColHeader,
            'mibi-text-cell--row-header': model.isRowHeader
        }"
    ><span class="mibi-text-cell__value">{{data}}</span></div>
</ng-template>

